import { Paper, Table, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { StackedTextCell } from '@retail/components';
import {
  AssortmentTagTableContent,
  AssortmentTagWithSupplierItemId,
} from './AssortmentTagTableContent';
import { useProductsTFunction } from '@retail/products/i18n';
import { SupplierItemWithAssortmentTags } from '@retail/products/types';
import { AssortmentTag } from '@retail/my-assortment/types';
import { TagTableCell } from './styles';

interface Props {
  supplierItemsTags: SupplierItemWithAssortmentTags[];
  assortmentTags: AssortmentTag[];
  readOnly?: boolean;
  setAssortmentTagToAdd?: (tag: AssortmentTagWithSupplierItemId) => void;
  setAssortmentTagToEdit?: (tag: AssortmentTagWithSupplierItemId) => void;
  setItemAssortmentTagToDelete?: (tag: AssortmentTag, mgSupplierItemId: number) => void;
  setSupplierItemToAddToAssortment?: (supplierItem: SupplierItemWithAssortmentTags) => void;
}

export function AssortmentTagTable({
  supplierItemsTags,
  assortmentTags,
  readOnly,
  setAssortmentTagToAdd,
  setAssortmentTagToEdit,
  setItemAssortmentTagToDelete,
  setSupplierItemToAddToAssortment,
}: Props) {
  const t = useProductsTFunction();
  return (
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={{ border: 0, borderRadius: 0, overflow: 'auto', width: 'auto' }}
    >
      <Table>
        <TableHead>
          <TableRow sx={{ height: 50, bgcolor: 'action.hover' }}>
            <TagTableCell>
              <Typography variant="subtitle2">{t('products.mgItem.assortments')}</Typography>
            </TagTableCell>
            {supplierItemsTags.map((supplierItem) => (
              <TagTableCell key={supplierItem.supplier.name} align="center">
                <StackedTextCell
                  topLine={supplierItem.supplier.name}
                  bottomLine={supplierItem.supplier.supplierNumber}
                />
              </TagTableCell>
            ))}
          </TableRow>
        </TableHead>

        <AssortmentTagTableContent
          supplierItemsTags={supplierItemsTags}
          assortmentTags={assortmentTags}
          readOnly={readOnly}
          setAssortmentTagToAdd={setAssortmentTagToAdd}
          setAssortmentTagToEdit={setAssortmentTagToEdit}
          setItemAssortmentTagToDelete={setItemAssortmentTagToDelete}
          setSupplierItemToAddToAssortment={setSupplierItemToAddToAssortment}
        />
      </Table>
    </TableContainer>
  );
}
